module.exports = __webpack_public_path__ + "img/carrot.b0636a3e.jpg";